/* Wording of a failed dynamic `import()` per engine: Chromium, Firefox, Safari. */
const CHUNK_LOAD_ERROR_MESSAGES = [
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
];

export const CHUNK_RELOAD_GRACE_MS = 10_000;

export const isChunkLoadError = (error: unknown): boolean => error instanceof TypeError
  && CHUNK_LOAD_ERROR_MESSAGES.some((message) => error.message.includes(message));

/* Nuxt answers a chunk error on navigation with a page reload, which makes a report moot. */
export const delayUnlessPageUnloads = async <T>(value: T): Promise<T | null> => {
  const listener = new AbortController();
  const unloaded = new Promise<null>((resolve) => {
    window.addEventListener('pagehide', () => resolve(null), { signal: listener.signal });
  });
  const graceElapsed = (async () => {
    await wait(CHUNK_RELOAD_GRACE_MS);
    return value;
  })();
  try {
    return await Promise.race([unloaded, graceElapsed]);
  } finally {
    listener.abort();
  }
};
